import React from "react"

import Container from "@ecom/ui/components/Container"

import cn from "classnames"
import * as styles from "./comparisonTable.module.scss"

import Cancel from "./img/Cancel"
import HalvaImg from "./img/HalvaImg"
import CreditCardImg from "./img/CreditCardImg"

type Props = {
  orderNum?: string
}

export default function ComparisonTable({ orderNum }: Props) {
  return (
    <section className={styles.section} data-exclude={orderNum}>
      <Container className={styles.container}>
        <div className={styles.secondContainer}>
          <CreditCardImg alt="credit сard" className={cn(styles.img, styles.creditCardImg)} />
          <HalvaImg alt="halva" className={cn(styles.img, styles.halvaImg)} />
          <table className={styles.table}>
            <thead>
              <tr>
                <td />
                <td className={styles.tableTitle}>
                  Кредитная <br /> карта
                </td>
                <td className={styles.tableTitle}>
                  Карта <br /> рассрочки*
                </td>
              </tr>
            </thead>
            <tbody>
              <tr className={cn(styles.tableRow, styles.tableRow1)}>
                <td className={styles.tableSubtitle}>
                  Льготный <br /> период
                </td>
                <td className={styles.tableText}>3 месяца</td>
                <td className={styles.tableText}>10 месяцев</td>
              </tr>
              <tr className={cn(styles.tableRow, styles.tableRow2)}>
                <td className={styles.tableSubtitle}>Выгода</td>
                <td>
                  <Cancel />
                </td>
                <td className={styles.tableText}>До +5% годовых к&nbsp;ставке вклада</td>
              </tr>
              <tr className={cn(styles.tableRow, styles.tableRow3)}>
                <td className={styles.tableSubtitle}>Кэшбэк</td>
                <td className={styles.tableText}>До 6%</td>
                <td className={styles.tableText}>До 10%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </section>
  )
}
